import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import classes from "../ModalReward.module.scss";
import { R_ACHIEVEMENTS } from "../../../constants/routes";

import chest_1 from "../../../assets/images/rewards/chest_1.png";
import chest_2 from "../../../assets/images/rewards/chest_2.png";
import chest_3 from "../../../assets/images/rewards/chest_3.png";
import chest_4 from "../../../assets/images/rewards/chest_4.png";
import * as kApi from "../../../constants/api";
import { PROD } from "../../../constants/defaults";
import {
  setAnalyticsNewMedalClick,
  setAnalyticsNewMedalView,
} from "../../../helpers/analyticsHelpers.js";

//! Refatorar o SVG

export function useModalReward(
  setInfoActivity,
  setOpenMedal,
  setOpenGame,
  rewards,
  setShowMedal,
  medalMap,
  showMedal
) {
  const navigate = useNavigate();

  const isProd = kApi.GET_PROD_OR_DEV === PROD;

  //###### BEGIN - FADE IN/OUT
  function fnFadeInOut(_value) {
    document.getElementById("black_fade").style.opacity = _value;
  }
  //###### END - FADE IN/OUT

  //###### BEGIN - OPEN CHEST
  const xFrame = useRef(0);
  const chestOpened = useRef(false);

  const ArrayChestFrameSet = [chest_1, chest_2, chest_3, chest_4];
  function AnimateChestFrameSet() {
    if (chestOpened.current == false) {
      document.getElementById("chest").src = ArrayChestFrameSet[xFrame.current];
      xFrame.current++;
      if (ArrayChestFrameSet.length == xFrame.current) {
        fnShowRibbows();
        fnShowBgMedal();
        fnShowMedal();
        fnShowStars();
        fnShowCloseButton();
        fnMinimizeChest();
        fnShowMessage();
        chestOpened.current = true;
      }
    }
  }
  //###### END - OPEN CHEST

  //###### BEGIN - SHOW RIBBOWS
  function fnShowRibbows() {
    document.getElementById("ribbows").style.transform = "scale(1.0, 1.0)";
  }
  //###### END - SHOW RIBBOEWS

  //###### BEGIN - BACKGROUND MEDAL
  function fnShowBgMedal() {
    document.getElementById("bgMedal").style.transform = "scale(1.0, 1.0)";
    document.getElementById("bgMedal").style.top = "-68%";

    setTimeout(function () {
      document
        .getElementById("bgMedal")
        .classList.toggle(classes.floatingMedal);
    }, 500);
  }
  //###### END - BACKGROUND MEDAL

  //###### BEGIN - MEDAL
  function fnShowMedal() {
    document.getElementById("medal").style.transform = "scale(1.0, 1.0)";
    document.getElementById("medal").style.top = "-70%";
    setTimeout(() => {
      document.getElementById("modal_medal").style.display = "block";
    }, 1000);

    setTimeout(function () {
      document.getElementById("medal").classList.toggle(classes.floatingMedal);
    }, 500);
  }
  //###### END - MEDAL

  //###### BEGIN - STARS
  function fnShowStars() {
    document.getElementById("star1").style.transform = "scale(1.0, 1.0)";
    document.getElementById("star1").style.width = "4%";
    document.getElementById("star1").style.top = "-77%";
    document.getElementById("star1").style.left = "-37%";

    document.getElementById("star2").style.transform = "scale(1.0, 1.0)";
    document.getElementById("star2").style.width = "13%";
    document.getElementById("star2").style.top = "-46%";
    document.getElementById("star2").style.left = "-59%";

    document.getElementById("star3").style.transform = "scale(1.0, 1.0)";
    document.getElementById("star3").style.width = "3%";
    document.getElementById("star3").style.top = "-39%";
    document.getElementById("star3").style.left = "-44%";

    document.getElementById("star4").style.transform = "scale(1.0, 1.0)";
    document.getElementById("star4").style.width = "8%";
    document.getElementById("star4").style.top = "-3%";
    document.getElementById("star4").style.left = "-18%";

    document.getElementById("star5").style.transform = "scale(1.0, 1.0)";
    document.getElementById("star5").style.width = "5%";
    document.getElementById("star5").style.top = "-80%";
    document.getElementById("star5").style.left = "33%";

    document.getElementById("star6").style.transform = "scale(1.0, 1.0)";
    document.getElementById("star6").style.width = "8%";
    document.getElementById("star6").style.top = "-48%";
    document.getElementById("star6").style.left = "64%";

    document.getElementById("star7").style.transform = "scale(1.0, 1.0)";
    document.getElementById("star7").style.width = "13%";
    document.getElementById("star7").style.top = "-30%";
    document.getElementById("star7").style.left = "37%";

    document.getElementById("star8").style.transform = "scale(1.0, 1.0)";
    document.getElementById("star8").style.width = "5%";
    document.getElementById("star8").style.top = "-15%";
    document.getElementById("star8").style.left = "21%";

    document.getElementById("starLight1").style.transform = "scale(1.0, 1.0)";
    document.getElementById("starLight1").style.width = "25%";
    document.getElementById("starLight1").style.top = "-32%";
    document.getElementById("starLight1").style.left = "-9%";

    document.getElementById("starLight2").style.transform = "scale(1.0, 1.0)";
    document.getElementById("starLight2").style.width = "10%";
    document.getElementById("starLight2").style.top = "0%";
    document.getElementById("starLight2").style.left = "0%";

    setTimeout(function () {
      document.getElementById("star1").classList.toggle(classes.starsRotation);
      document.getElementById("star2").classList.toggle(classes.starsRotation);
      document.getElementById("star3").classList.toggle(classes.starsRotation);
      document.getElementById("star4").classList.toggle(classes.starsRotation);
      document.getElementById("star5").classList.toggle(classes.starsRotation);
      document.getElementById("star6").classList.toggle(classes.starsRotation);
      document.getElementById("star7").classList.toggle(classes.starsRotation);
      document.getElementById("star8").classList.toggle(classes.starsRotation);

      document
        .getElementById("starLight1")
        .classList.toggle(classes.starsLightRotation);
      document
        .getElementById("starLight2")
        .classList.toggle(classes.starsLightRotation);
    }, 500);
  }
  //###### END - STARS

  //###### BEGIN - CLOSE BUTTON
  function fnShowCloseButton() {
    document.getElementById("closeButton").style.transform = "scale(1.0, 1.0)";
  }
  //###### END - CLOSE BUTTON

  //###### BEGIN - MINIMIZE CHEST
  function fnMinimizeChest() {
    setTimeout(function () {
      document.getElementById("chest").style.transform = "scale(0.6, 0.6)";
      document.getElementById("ribbows").style.opacity = "0.0";
    }, 500);
  }
  //###### END - MINIMIZE CHEST

  //###### BEGIN - MESSAGE
  function fnShowMessage() {
    setTimeout(function () {
      document.getElementById("message").style.transform = "scale(1.0, 1.0)";
    }, 500);
  }

  useEffect(() => {
    if (!showMedal && rewards) {
      // Verifica se existe alguma medalha nova (não está no medalMap ainda)
      const haveNewMedalLocal = rewards.reduce((hasNewMedal, medal) => {
        return hasNewMedal || (!!!medalMap[medal.medal_id]?medal.title:null);
      }, null);

      // Se achou medalha nova
      if (haveNewMedalLocal) {
        // Dispara evento de analytics (apenas em produção)
        if (isProd) {
          EventGoogleMedalView(haveNewMedalLocal);
        }
        // Mostra modal de medalha
        setShowMedal(true);

        // Inicia animação de fade
        fnFadeInOut("1.00");

        // Velocidade da animação do baú
        let chest_speed = 100;

        // Aguarda 500ms antes de começar animação do baú
        setTimeout(function () {
          document.getElementById("chest").style.transform = "scale(1.0, 1.0)";
          // Reseta flags da animação
          chestOpened.current = false;
          xFrame.current = 0;
          setInterval(AnimateChestFrameSet, chest_speed);
        }, 500);
      }
    }
  }, [rewards]);

  // Evento de analytics: exibe que o modal de medalha foi visto
  const EventGoogleMedalView = (medalName="") => {
    setAnalyticsNewMedalView(medalName);
  };

  // Evento de analytics: usuário clicou para ver suas conquistas
  const EventGoogleMedalClickMyConquest = (id) => {
    setAnalyticsNewMedalClick(id);
  };

  const handleNavigate = (id) => {
    isProd && EventGoogleMedalClickMyConquest(id);
    console.log("Navigating to:", `${R_ACHIEVEMENTS}?medal_id=${id}`);

    setInfoActivity(null); // fecha o modal de informações
    setOpenMedal(null); // fecha modal de medalhas aberto

    setTimeout(() => {
      setOpenGame(null); // fecha modal de jogo aberto)
      closeReward(); // fecha o modal atual
      navigate(`${R_ACHIEVEMENTS}?medal_id=${id}`); // redireciona
    }, 100);
    console.log("navigate");
  };

  //função para fechar o modal de conquistas
  const closeReward = () => {
    setShowMedal(false);
    fnFadeInOut(0);
    //tem q arrumar isso urgente
    document.getElementById("modal_medal").style.display = "none";
  };

  return { handleNavigate, closeReward };
}
